import { Box, Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { IAsyncStatus } from "../../Async/types";


interface AsyncStatusButtonProps {
    action: IAsyncStatus<any, any>;
    children: React.ReactNode;
    getErrorMessage?: (error: any) => string;
    onClick: () => void;
    disabled?: boolean;
    title?: string;
}

const AsyncStatusButton = (props: AsyncStatusButtonProps) => {

    const combinedDisabled = props.disabled === true || props.action.isBusy;

    return (
        <Box sx={{ m: 1, position: 'relative' }}>
            <Button
                variant="contained"
                disabled={combinedDisabled}
                onClick={props.onClick}
                title={props.title}
            >
            {props.children}
            </Button>
            {props.action.isBusy && (
                <CircularProgress
                    size={24}
                        sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px'
                    }}
                />
            )}
        </Box>
    );

}

export default AsyncStatusButton;